import Vue from 'vue'

const LOCALE_MAP: {
  [key: string]: string;
} = {
  de: 'de',
  en: 'en',
  fr: 'fr',
  it: 'it',
  nl: 'nl',
}

export default Vue.extend({
  computed: {
    availableLocales(): string[] {
      return this.$i18n.availableLocales.filter(
        (locale) => locale !== this.currentLocale,
      )
    },
    currentLocale(): string {
      return this.$i18n.locale
    },
    loading(): boolean {
      return this.$store.state.redemptions.loading
    },
    termsOfUseLocale(): string {
      return LOCALE_MAP[this.currentLocale] || 'en'
    },
  },
})
